/**
 * Generated by orval 🍺
 * Do not edit manually.
 * fleetster
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import axios from 'axios';
import type {
  AxiosError,
  AxiosRequestConfig,
  AxiosResponse
} from 'axios';

import type {
  ErrorEnvelope,
  GroupDto,
  MeDto,
  TenantUserDetailResultDto,
  TenantUserListResultDto,
  UpdateUserDto,
  UserDto,
  UserFilterOptionsDto,
  UsersControllerListUsersParams
} from '../../models';





const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const meControllerGetMe = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<MeDto>> => {


    return axios.get(
      `/api/me`,options
    );
  }

export const getMeControllerGetMeUrl = () => {

  return axios.create({
    baseURL: '',
    params: null,
  }).getUri({
    url: `/api/me`,
    baseURL: '',


  });
}




export const getMeControllerGetMeQueryKey = () => {
    return [
    `/api/me`
    ] as const;
    }


export const getMeControllerGetMeQueryOptions = <TData = Awaited<ReturnType<typeof meControllerGetMe>>, TError = AxiosError<ErrorEnvelope>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meControllerGetMe>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMeControllerGetMeQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof meControllerGetMe>>> = ({ signal }) => meControllerGetMe({ signal, ...axiosOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof meControllerGetMe>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MeControllerGetMeQueryResult = NonNullable<Awaited<ReturnType<typeof meControllerGetMe>>>
export type MeControllerGetMeQueryError = AxiosError<ErrorEnvelope>


export function useMeControllerGetMe<TData = Awaited<ReturnType<typeof meControllerGetMe>>, TError = AxiosError<ErrorEnvelope>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof meControllerGetMe>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof meControllerGetMe>>,
          TError,
          Awaited<ReturnType<typeof meControllerGetMe>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMeControllerGetMe<TData = Awaited<ReturnType<typeof meControllerGetMe>>, TError = AxiosError<ErrorEnvelope>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meControllerGetMe>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof meControllerGetMe>>,
          TError,
          Awaited<ReturnType<typeof meControllerGetMe>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMeControllerGetMe<TData = Awaited<ReturnType<typeof meControllerGetMe>>, TError = AxiosError<ErrorEnvelope>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meControllerGetMe>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useMeControllerGetMe<TData = Awaited<ReturnType<typeof meControllerGetMe>>, TError = AxiosError<ErrorEnvelope>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meControllerGetMe>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMeControllerGetMeQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const usersControllerListUsers = (
    params?: UsersControllerListUsersParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<TenantUserListResultDto>> => {


    return axios.get(
      `/api/users`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getUsersControllerListUsersUrl = (params?: UsersControllerListUsersParams,) => {

  return axios.create({
    baseURL: '',
    params: null,
  }).getUri({
    url: `/api/users`,
    baseURL: '',
    params,

  });
}




export const getUsersControllerListUsersQueryKey = (params?: UsersControllerListUsersParams,) => {
    return [
    `/api/users`, ...(params ? [params] : [])
    ] as const;
    }


export const getUsersControllerListUsersQueryOptions = <TData = Awaited<ReturnType<typeof usersControllerListUsers>>, TError = AxiosError<ErrorEnvelope>>(params?: UsersControllerListUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersControllerListUsers>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersControllerListUsersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersControllerListUsers>>> = ({ signal }) => usersControllerListUsers(params, { signal, ...axiosOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersControllerListUsers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsersControllerListUsersQueryResult = NonNullable<Awaited<ReturnType<typeof usersControllerListUsers>>>
export type UsersControllerListUsersQueryError = AxiosError<ErrorEnvelope>


export function useUsersControllerListUsers<TData = Awaited<ReturnType<typeof usersControllerListUsers>>, TError = AxiosError<ErrorEnvelope>>(
 params: undefined |  UsersControllerListUsersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersControllerListUsers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersControllerListUsers>>,
          TError,
          Awaited<ReturnType<typeof usersControllerListUsers>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersControllerListUsers<TData = Awaited<ReturnType<typeof usersControllerListUsers>>, TError = AxiosError<ErrorEnvelope>>(
 params?: UsersControllerListUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersControllerListUsers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersControllerListUsers>>,
          TError,
          Awaited<ReturnType<typeof usersControllerListUsers>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersControllerListUsers<TData = Awaited<ReturnType<typeof usersControllerListUsers>>, TError = AxiosError<ErrorEnvelope>>(
 params?: UsersControllerListUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersControllerListUsers>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUsersControllerListUsers<TData = Awaited<ReturnType<typeof usersControllerListUsers>>, TError = AxiosError<ErrorEnvelope>>(
 params?: UsersControllerListUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersControllerListUsers>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsersControllerListUsersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const usersControllerGetFilterOptions = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<UserFilterOptionsDto>> => {


    return axios.get(
      `/api/users/filter-options`,options
    );
  }

export const getUsersControllerGetFilterOptionsUrl = () => {

  return axios.create({
    baseURL: '',
    params: null,
  }).getUri({
    url: `/api/users/filter-options`,
    baseURL: '',


  });
}




export const getUsersControllerGetFilterOptionsQueryKey = () => {
    return [
    `/api/users/filter-options`
    ] as const;
    }


export const getUsersControllerGetFilterOptionsQueryOptions = <TData = Awaited<ReturnType<typeof usersControllerGetFilterOptions>>, TError = AxiosError<ErrorEnvelope>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersControllerGetFilterOptions>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersControllerGetFilterOptionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersControllerGetFilterOptions>>> = ({ signal }) => usersControllerGetFilterOptions({ signal, ...axiosOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersControllerGetFilterOptions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsersControllerGetFilterOptionsQueryResult = NonNullable<Awaited<ReturnType<typeof usersControllerGetFilterOptions>>>
export type UsersControllerGetFilterOptionsQueryError = AxiosError<ErrorEnvelope>


export function useUsersControllerGetFilterOptions<TData = Awaited<ReturnType<typeof usersControllerGetFilterOptions>>, TError = AxiosError<ErrorEnvelope>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersControllerGetFilterOptions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersControllerGetFilterOptions>>,
          TError,
          Awaited<ReturnType<typeof usersControllerGetFilterOptions>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersControllerGetFilterOptions<TData = Awaited<ReturnType<typeof usersControllerGetFilterOptions>>, TError = AxiosError<ErrorEnvelope>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersControllerGetFilterOptions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersControllerGetFilterOptions>>,
          TError,
          Awaited<ReturnType<typeof usersControllerGetFilterOptions>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersControllerGetFilterOptions<TData = Awaited<ReturnType<typeof usersControllerGetFilterOptions>>, TError = AxiosError<ErrorEnvelope>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersControllerGetFilterOptions>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUsersControllerGetFilterOptions<TData = Awaited<ReturnType<typeof usersControllerGetFilterOptions>>, TError = AxiosError<ErrorEnvelope>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersControllerGetFilterOptions>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsersControllerGetFilterOptionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const usersControllerGetUser = (
    userId: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<TenantUserDetailResultDto>> => {


    return axios.get(
      `/api/users/${userId}`,options
    );
  }

export const getUsersControllerGetUserUrl = (userId: string,) => {

  return axios.create({
    baseURL: '',
    params: null,
  }).getUri({
    url: `/api/users/${userId}`,
    baseURL: '',


  });
}




export const getUsersControllerGetUserQueryKey = (userId: string,) => {
    return [
    `/api/users/${userId}`
    ] as const;
    }


export const getUsersControllerGetUserQueryOptions = <TData = Awaited<ReturnType<typeof usersControllerGetUser>>, TError = AxiosError<ErrorEnvelope>>(userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersControllerGetUser>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersControllerGetUserQueryKey(userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersControllerGetUser>>> = ({ signal }) => usersControllerGetUser(userId, { signal, ...axiosOptions });





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersControllerGetUser>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsersControllerGetUserQueryResult = NonNullable<Awaited<ReturnType<typeof usersControllerGetUser>>>
export type UsersControllerGetUserQueryError = AxiosError<ErrorEnvelope>


export function useUsersControllerGetUser<TData = Awaited<ReturnType<typeof usersControllerGetUser>>, TError = AxiosError<ErrorEnvelope>>(
 userId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersControllerGetUser>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersControllerGetUser>>,
          TError,
          Awaited<ReturnType<typeof usersControllerGetUser>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersControllerGetUser<TData = Awaited<ReturnType<typeof usersControllerGetUser>>, TError = AxiosError<ErrorEnvelope>>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersControllerGetUser>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersControllerGetUser>>,
          TError,
          Awaited<ReturnType<typeof usersControllerGetUser>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersControllerGetUser<TData = Awaited<ReturnType<typeof usersControllerGetUser>>, TError = AxiosError<ErrorEnvelope>>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersControllerGetUser>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUsersControllerGetUser<TData = Awaited<ReturnType<typeof usersControllerGetUser>>, TError = AxiosError<ErrorEnvelope>>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersControllerGetUser>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsersControllerGetUserQueryOptions(userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const usersControllerUpdateUser = (
    userId: string,
    updateUserDto: UpdateUserDto, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<TenantUserDetailResultDto>> => {


    return axios.patch(
      `/api/users/${userId}`,
      updateUserDto,options
    );
  }

export const getUsersControllerUpdateUserUrl = (userId: string,) => {

  return axios.create({
    baseURL: '',
    params: null,
  }).getUri({
    url: `/api/users/${userId}`,
    baseURL: '',


  });
}




export const getUsersControllerUpdateUserMutationKey = () => ['usersControllerUpdateUser'] as const;

export const getUsersControllerUpdateUserMutationOptions = <TError = AxiosError<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usersControllerUpdateUser>>, TError,UsersControllerUpdateUserMutationVariables, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof usersControllerUpdateUser>>, TError,UsersControllerUpdateUserMutationVariables, TContext> => {

const mutationKey = getUsersControllerUpdateUserMutationKey();
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof usersControllerUpdateUser>>, UsersControllerUpdateUserMutationVariables> = (props) => {
          const {userId,data} = props ?? {};

          return  usersControllerUpdateUser(userId,data,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UsersControllerUpdateUserMutationResult = NonNullable<Awaited<ReturnType<typeof usersControllerUpdateUser>>>
    export type UsersControllerUpdateUserMutationBody = UpdateUserDto
    export type UsersControllerUpdateUserMutationError = AxiosError<ErrorEnvelope>
    export type UsersControllerUpdateUserMutationVariables = {userId: string;data: UpdateUserDto}

    export const useUsersControllerUpdateUser = <TError = AxiosError<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usersControllerUpdateUser>>, TError,UsersControllerUpdateUserMutationVariables, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof usersControllerUpdateUser>>,
        TError,
        UsersControllerUpdateUserMutationVariables,
        TContext
      > => {
      return useMutation(getUsersControllerUpdateUserMutationOptions(options), queryClient);
    }
    export const usersControllerActivateUser = (
    userId: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<TenantUserDetailResultDto>> => {


    return axios.post(
      `/api/users/${userId}/activate`,
      undefined,options
    );
  }

export const getUsersControllerActivateUserUrl = (userId: string,) => {

  return axios.create({
    baseURL: '',
    params: null,
  }).getUri({
    url: `/api/users/${userId}/activate`,
    baseURL: '',


  });
}




export const getUsersControllerActivateUserMutationKey = () => ['usersControllerActivateUser'] as const;

export const getUsersControllerActivateUserMutationOptions = <TError = AxiosError<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usersControllerActivateUser>>, TError,UsersControllerActivateUserMutationVariables, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof usersControllerActivateUser>>, TError,UsersControllerActivateUserMutationVariables, TContext> => {

const mutationKey = getUsersControllerActivateUserMutationKey();
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof usersControllerActivateUser>>, UsersControllerActivateUserMutationVariables> = (props) => {
          const {userId} = props ?? {};

          return  usersControllerActivateUser(userId,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UsersControllerActivateUserMutationResult = NonNullable<Awaited<ReturnType<typeof usersControllerActivateUser>>>

    export type UsersControllerActivateUserMutationError = AxiosError<ErrorEnvelope>
    export type UsersControllerActivateUserMutationVariables = {userId: string}

    export const useUsersControllerActivateUser = <TError = AxiosError<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usersControllerActivateUser>>, TError,UsersControllerActivateUserMutationVariables, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof usersControllerActivateUser>>,
        TError,
        UsersControllerActivateUserMutationVariables,
        TContext
      > => {
      return useMutation(getUsersControllerActivateUserMutationOptions(options), queryClient);
    }
    export const usersControllerDeactivateUser = (
    userId: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<TenantUserDetailResultDto>> => {


    return axios.post(
      `/api/users/${userId}/deactivate`,
      undefined,options
    );
  }

export const getUsersControllerDeactivateUserUrl = (userId: string,) => {

  return axios.create({
    baseURL: '',
    params: null,
  }).getUri({
    url: `/api/users/${userId}/deactivate`,
    baseURL: '',


  });
}




export const getUsersControllerDeactivateUserMutationKey = () => ['usersControllerDeactivateUser'] as const;

export const getUsersControllerDeactivateUserMutationOptions = <TError = AxiosError<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usersControllerDeactivateUser>>, TError,UsersControllerDeactivateUserMutationVariables, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof usersControllerDeactivateUser>>, TError,UsersControllerDeactivateUserMutationVariables, TContext> => {

const mutationKey = getUsersControllerDeactivateUserMutationKey();
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof usersControllerDeactivateUser>>, UsersControllerDeactivateUserMutationVariables> = (props) => {
          const {userId} = props ?? {};

          return  usersControllerDeactivateUser(userId,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UsersControllerDeactivateUserMutationResult = NonNullable<Awaited<ReturnType<typeof usersControllerDeactivateUser>>>

    export type UsersControllerDeactivateUserMutationError = AxiosError<ErrorEnvelope>
    export type UsersControllerDeactivateUserMutationVariables = {userId: string}

    export const useUsersControllerDeactivateUser = <TError = AxiosError<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usersControllerDeactivateUser>>, TError,UsersControllerDeactivateUserMutationVariables, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof usersControllerDeactivateUser>>,
        TError,
        UsersControllerDeactivateUserMutationVariables,
        TContext
      > => {
      return useMutation(getUsersControllerDeactivateUserMutationOptions(options), queryClient);
    }
    export const groupsControllerGetGroups = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GroupDto[]>> => {


    return axios.get(
      `/api/groups`,options
    );
  }

export const getGroupsControllerGetGroupsUrl = () => {

  return axios.create({
    baseURL: '',
    params: null,
  }).getUri({
    url: `/api/groups`,
    baseURL: '',


  });
}




export const getGroupsControllerGetGroupsQueryKey = () => {
    return [
    `/api/groups`
    ] as const;
    }


export const getGroupsControllerGetGroupsQueryOptions = <TData = Awaited<ReturnType<typeof groupsControllerGetGroups>>, TError = AxiosError<ErrorEnvelope>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof groupsControllerGetGroups>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGroupsControllerGetGroupsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof groupsControllerGetGroups>>> = ({ signal }) => groupsControllerGetGroups({ signal, ...axiosOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof groupsControllerGetGroups>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GroupsControllerGetGroupsQueryResult = NonNullable<Awaited<ReturnType<typeof groupsControllerGetGroups>>>
export type GroupsControllerGetGroupsQueryError = AxiosError<ErrorEnvelope>


export function useGroupsControllerGetGroups<TData = Awaited<ReturnType<typeof groupsControllerGetGroups>>, TError = AxiosError<ErrorEnvelope>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof groupsControllerGetGroups>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof groupsControllerGetGroups>>,
          TError,
          Awaited<ReturnType<typeof groupsControllerGetGroups>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGroupsControllerGetGroups<TData = Awaited<ReturnType<typeof groupsControllerGetGroups>>, TError = AxiosError<ErrorEnvelope>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof groupsControllerGetGroups>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof groupsControllerGetGroups>>,
          TError,
          Awaited<ReturnType<typeof groupsControllerGetGroups>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGroupsControllerGetGroups<TData = Awaited<ReturnType<typeof groupsControllerGetGroups>>, TError = AxiosError<ErrorEnvelope>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof groupsControllerGetGroups>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGroupsControllerGetGroups<TData = Awaited<ReturnType<typeof groupsControllerGetGroups>>, TError = AxiosError<ErrorEnvelope>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof groupsControllerGetGroups>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGroupsControllerGetGroupsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const devUsersControllerListAllUsers = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<UserDto[]>> => {


    return axios.get(
      `/api/dev/users`,options
    );
  }

export const getDevUsersControllerListAllUsersUrl = () => {

  return axios.create({
    baseURL: '',
    params: null,
  }).getUri({
    url: `/api/dev/users`,
    baseURL: '',


  });
}




export const getDevUsersControllerListAllUsersQueryKey = () => {
    return [
    `/api/dev/users`
    ] as const;
    }


export const getDevUsersControllerListAllUsersQueryOptions = <TData = Awaited<ReturnType<typeof devUsersControllerListAllUsers>>, TError = AxiosError<ErrorEnvelope>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof devUsersControllerListAllUsers>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDevUsersControllerListAllUsersQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof devUsersControllerListAllUsers>>> = ({ signal }) => devUsersControllerListAllUsers({ signal, ...axiosOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof devUsersControllerListAllUsers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DevUsersControllerListAllUsersQueryResult = NonNullable<Awaited<ReturnType<typeof devUsersControllerListAllUsers>>>
export type DevUsersControllerListAllUsersQueryError = AxiosError<ErrorEnvelope>


export function useDevUsersControllerListAllUsers<TData = Awaited<ReturnType<typeof devUsersControllerListAllUsers>>, TError = AxiosError<ErrorEnvelope>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof devUsersControllerListAllUsers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof devUsersControllerListAllUsers>>,
          TError,
          Awaited<ReturnType<typeof devUsersControllerListAllUsers>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDevUsersControllerListAllUsers<TData = Awaited<ReturnType<typeof devUsersControllerListAllUsers>>, TError = AxiosError<ErrorEnvelope>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof devUsersControllerListAllUsers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof devUsersControllerListAllUsers>>,
          TError,
          Awaited<ReturnType<typeof devUsersControllerListAllUsers>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDevUsersControllerListAllUsers<TData = Awaited<ReturnType<typeof devUsersControllerListAllUsers>>, TError = AxiosError<ErrorEnvelope>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof devUsersControllerListAllUsers>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDevUsersControllerListAllUsers<TData = Awaited<ReturnType<typeof devUsersControllerListAllUsers>>, TError = AxiosError<ErrorEnvelope>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof devUsersControllerListAllUsers>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDevUsersControllerListAllUsersQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






